(function () {
  var MAX_WIDTH = 1080;
  var CACHE_KEY = "wus-tryon-last-person";
  var CACHE_WIDTH = 720;
  var CACHE_QUALITY = 0.7;
  var CACHE_MAX = 280000;
  var TOP_TYPES = {
    "t-shirt": 1,
    "long sleeve t-shirt": 1,
    "polo t-shirt": 1,
    "tank top": 1,
    sweatshirt: 1,
    hoodie: 1,
    jacket: 1,
    "track top": 1,
    jersey: 1,
    "sports bra": 1,
    rashguard: 1,
    vest: 1,
    windbreaker: 1,
  };
  var BOTTOM_TYPES = { shorts: 1, pants: 1, leggings: 1, boxer: 1, skirt: 1, joggers: 1 };
  var FULL_TYPES = { "matching set": 1, tracksuit: 1, dress: 1, jumpsuit: 1 };

  function normalizeKey(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function garmentSlot(product) {
    var division = normalizeKey(product.division);
    if (division === "footwear") return "shoe";
    var kind = normalizeKey(product.productType);
    if (TOP_TYPES[kind]) return "top";
    if (BOTTOM_TYPES[kind]) return "bottom";
    if (FULL_TYPES[kind]) return "full";
    if (
      kind.indexOf("shoe") >= 0 ||
      kind.indexOf("sneaker") >= 0 ||
      kind.indexOf("boot") >= 0 ||
      kind.indexOf("sandal") >= 0 ||
      kind.indexOf("slide") >= 0 ||
      kind === "footwear"
    ) {
      return "shoe";
    }
    if (division === "apparel") return "full";
    return "other";
  }

  function takenSlots(list) {
    var taken = { top: false, bottom: false, shoe: false };
    list.forEach(function (p) {
      var slot = garmentSlot(p);
      if (slot === "full") {
        taken.top = true;
        taken.bottom = true;
      } else if (slot === "top" || slot === "bottom" || slot === "shoe") {
        taken[slot] = true;
      }
    });
    return taken;
  }

  function limitOutfit(list) {
    var taken = { top: false, bottom: false, shoe: false };
    var out = [];
    list.forEach(function (p) {
      var slot = garmentSlot(p);
      if (slot === "other") return;
      if (slot === "full") {
        if (taken.top || taken.bottom) return;
        taken.top = true;
        taken.bottom = true;
        out.push(p);
        return;
      }
      if (taken[slot]) return;
      taken[slot] = true;
      out.push(p);
    });
    return out;
  }

  function slotLocked(product, selected, taken) {
    if (selected) return false;
    var slot = garmentSlot(product);
    if (slot === "full") return taken.top || taken.bottom;
    if (slot === "other") return true;
    return !!taken[slot];
  }
  var root = null;
  var stream = null;
  var facing = "user";
  var tripod = false;
  var detectTimer = null;
  var countdownTimer = null;
  var faceDetector = null;
  var personBlob = null;
  var modelGender = null;
  var products = [];
  var pickMode = false;
  var selectedIds = {};
  var zoomScale = 1;

  function t(key, fallback) {
    if (!root) return fallback;
    return root.getAttribute("data-i18n-" + key) || fallback;
  }

  function ageBand(product) {
    var age = String(product.ageGroup || "").toLowerCase();
    var gender = String(product.gender || "").toLowerCase();
    if (
      gender === "kids" ||
      age === "youth" ||
      age === "toddlers" ||
      age === "babies" ||
      age === "kids" ||
      age === "child"
    ) {
      return "kids";
    }
    return "adult";
  }

  function selectedProducts() {
    if (!pickMode) return products.slice(0, 1);
    return limitOutfit(
      products.filter(function (p) {
        return selectedIds[String(p.id)];
      })
    );
  }

  function lockedBand() {
    var sel = selectedProducts();
    return sel.length ? ageBand(sel[0]) : null;
  }

  function stopStream() {
    if (detectTimer) {
      clearInterval(detectTimer);
      detectTimer = null;
    }
    if (countdownTimer) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    }
    if (stream) {
      stream.getTracks().forEach(function (track) {
        track.stop();
      });
      stream = null;
    }
  }

  function close() {
    stopStream();
    personBlob = null;
    modelGender = null;
    products = [];
    pickMode = false;
    selectedIds = {};
    zoomScale = 1;
    if (root) root.hidden = true;
    document.documentElement.style.removeProperty("overflow");
    document.body.style.removeProperty("overflow");
    document.getElementById("wus-tryon-fs")?.remove();
  }

  function beep(freq, ms) {
    try {
      var ctx = new (window.AudioContext || window.webkitAudioContext)();
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.frequency.value = freq || 880;
      gain.gain.value = 0.08;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start();
      setTimeout(function () {
        osc.stop();
        ctx.close();
      }, ms || 120);
    } catch (_e) {}
  }

  function footer(html) {
    var el = root.querySelector("[data-tryon-footer]");
    if (el) el.innerHTML = html;
  }

  function content(html) {
    var el = root.querySelector("[data-tryon-content]");
    if (el) el.innerHTML = html;
  }

  function loadLastPhoto() {
    try {
      var value = localStorage.getItem(CACHE_KEY);
      return value && value.indexOf("data:image/") === 0 ? value : "";
    } catch (_e) {
      return "";
    }
  }

  function clearLastPhoto() {
    try {
      localStorage.removeItem(CACHE_KEY);
    } catch (_e) {}
  }

  function compressForCache(blob) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var objectUrl = URL.createObjectURL(blob);
      img.onload = function () {
        URL.revokeObjectURL(objectUrl);
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        if (w > CACHE_WIDTH) {
          h = Math.round((h * CACHE_WIDTH) / w);
          w = CACHE_WIDTH;
        }
        var canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
        var quality = CACHE_QUALITY;
        var dataUrl = canvas.toDataURL("image/jpeg", quality);
        while (dataUrl.length > CACHE_MAX && quality > 0.4) {
          quality -= 0.1;
          dataUrl = canvas.toDataURL("image/jpeg", quality);
        }
        resolve(dataUrl.length > CACHE_MAX ? "" : dataUrl);
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("compress"));
      };
      img.src = objectUrl;
    });
  }

  async function saveLastPhoto(blob) {
    if (!blob) return;
    try {
      var dataUrl = await compressForCache(blob);
      if (!dataUrl) return;
      localStorage.setItem(CACHE_KEY, dataUrl);
    } catch (_e) {
      try {
        localStorage.removeItem(CACHE_KEY);
      } catch (_err) {}
    }
  }

  function showSource() {
    var last = loadLastPhoto();
    content(
      '<p class="wus-tryon-lead">' +
        escapeHtml(t("source", "How do you want to try on?")) +
        "</p><div class=\"wus-tryon-pills\">" +
        (last
          ? '<button type="button" class="wus-tryon-pill wus-tryon-last" data-act="last">' +
            '<img alt="" src="' +
            last +
            '"><span>' +
            escapeHtml(t("last", "Use last photo")) +
            "</span></button>"
          : "") +
        '<button type="button" class="wus-tryon-pill" data-act="camera">' +
        escapeHtml(t("camera", "Open camera")) +
        "</button>" +
        '<button type="button" class="wus-tryon-pill" data-act="male">' +
        escapeHtml(t("male", "Male model")) +
        "</button>" +
        '<button type="button" class="wus-tryon-pill" data-act="female">' +
        escapeHtml(t("female", "Female model")) +
        "</button>" +
        (last
          ? '<button type="button" class="wus-tryon-pill wus-tryon-last-clear" data-act="last-clear">' +
            escapeHtml(t("last-clear", "Remove saved photo")) +
            "</button>"
          : "") +
        "</div>"
    );
    footer("");
    root.querySelector("[data-act='last']")?.addEventListener("click", async function () {
      modelGender = null;
      try {
        personBlob = await (await fetch(last)).blob();
        showConfirm(last);
      } catch (_e) {
        clearLastPhoto();
        startCamera();
      }
    });
    root.querySelector("[data-act='last-clear']")?.addEventListener("click", function () {
      clearLastPhoto();
      showSource();
    });
    root.querySelector("[data-act='camera']")?.addEventListener("click", function () {
      modelGender = null;
      startCamera();
    });
    root.querySelector("[data-act='male']")?.addEventListener("click", function () {
      personBlob = null;
      modelGender = "male";
      afterPerson();
    });
    root.querySelector("[data-act='female']")?.addEventListener("click", function () {
      personBlob = null;
      modelGender = "female";
      afterPerson();
    });
  }

  async function startCamera() {
    stopStream();
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: facing, width: { ideal: 1280 } },
        audio: false,
      });
    } catch (_e) {
      content('<p class="wus-tryon-err">' + escapeHtml(t("error", "Could not open camera")) + "</p>");
      footer(
        '<button type="button" class="wus-tryon-cta secondary" data-act="back">' +
          escapeHtml(t("close", "Close")) +
          "</button>"
      );
      root.querySelector("[data-act='back']")?.addEventListener("click", showSource);
      return;
    }

    content(
      '<div class="wus-tryon-stack">' +
        '<div class="wus-tryon-stage"><video class="wus-tryon-video" data-tryon-video autoplay playsinline muted></video>' +
        (tripod
          ? '<span class="wus-tryon-badge">' + escapeHtml(t("tripod-on", "Tripod: on")) + "</span>"
          : "") +
        '<div class="wus-tryon-count" data-tryon-count hidden></div></div>' +
        (tripod
          ? '<p class="wus-tryon-hint" data-tryon-status>' +
            escapeHtml(t("detector", "Starting tripod mode…")) +
            "</p>"
          : "") +
        "</div>"
    );
    footer(
      '<div class="wus-tryon-cam-bar">' +
        '<button type="button" class="wus-tryon-icon-btn" data-act="flip" aria-label="' +
        escapeAttr(t("flip", "Flip camera")) +
        '">' +
        iconFlip() +
        '<span>' +
        escapeHtml(t("flip", "Flip camera")) +
        "</span></button>" +
        '<button type="button" class="wus-tryon-shutter" data-act="shot" aria-label="' +
        escapeAttr(t("capture", "Take photo")) +
        '"></button>' +
        '<button type="button" class="wus-tryon-icon-btn' +
        (tripod ? " is-on" : "") +
        '" data-act="tripod" aria-pressed="' +
        (tripod ? "true" : "false") +
        '" aria-label="' +
        escapeAttr(tripod ? t("tripod-on", "Tripod: on") : t("tripod-off", "Tripod: off")) +
        '">' +
        iconTripod() +
        "<span>" +
        escapeHtml(t("tripod", "Tripod mode")) +
        "</span></button>" +
        "</div>"
    );

    var video = root.querySelector("[data-tryon-video]");
    if (video) video.srcObject = stream;

    root.querySelector("[data-act='flip']")?.addEventListener("click", function () {
      facing = facing === "user" ? "environment" : "user";
      startCamera();
    });
    root.querySelector("[data-act='tripod']")?.addEventListener("click", function () {
      tripod = !tripod;
      startCamera();
    });
    root.querySelector("[data-act='shot']")?.addEventListener("click", function () {
      grabFrame(video);
    });

    if (tripod) watchTripod(video);
  }

  async function loadDetector() {
    if (faceDetector) return faceDetector;
    var mp = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.21";
    var mod = await import(mp);
    var fileset = await mod.FilesetResolver.forVisionTasks(mp + "/wasm");
    faceDetector = await mod.FaceDetector.createFromOptions(fileset, {
      baseOptions: {
        modelAssetPath:
          "https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite",
      },
      runningMode: "VIDEO",
    });
    return faceDetector;
  }

  function setStatus(text) {
    var el = root.querySelector("[data-tryon-status]");
    if (el) el.textContent = text;
  }

  function watchTripod(video) {
    var hits = 0;
    var counting = false;
    setStatus(t("detector", "Starting tripod mode…"));
    loadDetector()
      .then(function () {
        setStatus(t("looking", "Looking for you…"));
      })
      .catch(function () {
        faceDetector = null;
        setStatus(t("detect-fail", "Auto-detect unavailable — tap Take photo"));
      });
    detectTimer = setInterval(function () {
      if (counting || !video || video.readyState < 2) return;
      if (!faceDetector) return;
      var found = false;
      try {
        var now = performance.now();
        var res = faceDetector.detectForVideo(video, now);
        found = (res.detections || []).length > 0;
      } catch (_e) {
        found = false;
      }
      if (found) {
        hits += 1;
        beep(720, 80);
        setStatus(t("detected", "Seen you — countdown starting"));
        if (hits >= 3) {
          counting = true;
          startCountdown(video);
        }
      } else {
        hits = 0;
        setStatus(t("looking", "Looking for you…"));
      }
    }, 400);
  }

  function startCountdown(video) {
    var n = 10;
    var el = root.querySelector("[data-tryon-count]");
    if (el) {
      el.hidden = false;
      el.textContent = String(n);
    }
    beep(520, 100);
    countdownTimer = setInterval(function () {
      n -= 1;
      if (el) el.textContent = n > 0 ? String(n) : "";
      beep(n > 0 ? 520 : 980, n > 0 ? 100 : 180);
      if (n <= 0) {
        clearInterval(countdownTimer);
        countdownTimer = null;
        grabFrame(video);
      }
    }, 1000);
  }

  function grabFrame(video) {
    if (!video || video.videoWidth < 2) return;
    var canvas = document.createElement("canvas");
    var w = video.videoWidth;
    var h = video.videoHeight;
    if (w > MAX_WIDTH) {
      h = Math.round((h * MAX_WIDTH) / w);
      w = MAX_WIDTH;
    }
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(video, 0, 0, w, h);
    stopStream();
    canvas.toBlob(
      function (blob) {
        personBlob = blob;
        showConfirm(canvas.toDataURL("image/jpeg", 0.9));
      },
      "image/jpeg",
      0.9
    );
  }

  function showConfirm(dataUrl) {
    content('<img class="wus-tryon-shot" alt="" src="' + dataUrl + '">');
    footer(
      '<button type="button" class="wus-tryon-cta secondary" data-act="retake">' +
        escapeHtml(t("retake", "Retake")) +
        "</button>" +
        '<button type="button" class="wus-tryon-cta" data-act="use">' +
        escapeHtml(t("confirm", "Use this photo")) +
        "</button>"
    );
    root.querySelector("[data-act='retake']")?.addEventListener("click", function () {
      personBlob = null;
      startCamera();
    });
    root.querySelector("[data-act='use']")?.addEventListener("click", function () {
      saveLastPhoto(personBlob);
      afterPerson();
    });
  }

  function afterPerson() {
    if (pickMode) showPicker();
    else generate();
  }

  function showPicker() {
    var band = lockedBand();
    var taken = takenSlots(selectedProducts());
    var rows = products
      .map(function (p) {
        var id = String(p.id);
        var itemBand = ageBand(p);
        var checked = !!selectedIds[id];
        var locked =
          (band && itemBand !== band && !checked) || slotLocked(p, checked, taken);
        return (
          '<div class="wus-tryon-item' +
          (locked ? " is-locked" : "") +
          (checked ? " is-selected" : "") +
          '">' +
          (p.imageUrl ? '<img alt="" src="' + escapeAttr(p.imageUrl) + '">' : "<span></span>") +
          "<label>" +
          escapeHtml(p.title || id) +
          '</label><input type="checkbox" data-pid="' +
          escapeAttr(id) +
          '"' +
          (checked ? " checked" : "") +
          (locked ? " disabled" : "") +
          "></div>"
        );
      })
      .join("");

    content(
      '<p class="wus-tryon-lead">' +
        escapeHtml(t("pick", "Choose products")) +
        "</p>" +
        '<p class="wus-tryon-hint">' +
        escapeHtml(t("slots", "One top, one bottom, and one pair of shoes")) +
        "</p>" +
        (band
          ? '<p class="wus-tryon-hint">' + escapeHtml(t("mix", "Adult and kids products cannot be mixed")) + "</p>"
          : "") +
        '<div class="wus-tryon-stack">' +
        rows +
        "</div>"
    );
    footer(
      '<button type="button" class="wus-tryon-cta" data-act="go" ' +
        (selectedProducts().length ? "" : "disabled") +
        ">" +
        escapeHtml(t("generate", "Generate")) +
        "</button>"
    );

    root.querySelectorAll("input[data-pid]").forEach(function (box) {
      box.addEventListener("change", function () {
        if (box.checked) selectedIds[box.dataset.pid] = true;
        else delete selectedIds[box.dataset.pid];
        var kept = {};
        limitOutfit(
          products.filter(function (p) {
            return selectedIds[String(p.id)];
          })
        ).forEach(function (p) {
          kept[String(p.id)] = true;
        });
        selectedIds = kept;
        showPicker();
      });
    });
    root.querySelector("[data-act='go']")?.addEventListener("click", generate);
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async function generate() {
    var chosen = selectedProducts();
    if (!chosen.length) return;
    content(
      '<div class="wus-tryon-loading"><span class="wus-tryon-spinner" aria-hidden="true"></span>' +
        '<p class="wus-tryon-lead">' +
        escapeHtml(t("loading", "Creating your look…")) +
        "</p></div>"
    );
    footer("");

    var body = {
      modelGender: modelGender || undefined,
      products: chosen.map(function (p) {
        return {
          id: p.id,
          title: p.title,
          imageUrl: p.imageUrl && p.imageUrl.indexOf("//") === 0 ? "https:" + p.imageUrl : p.imageUrl,
          ageGroup: p.ageGroup,
          gender: p.gender,
          productType: p.productType,
          division: p.division,
          sku: p.sku,
        };
      }),
    };
    if (personBlob) body.personImage = await blobToDataUrl(personBlob);

    try {
      var res = await fetch(root.getAttribute("data-api"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      var json = await res.json();
      if (!res.ok || !json.success || !json.image) {
        throw new Error(json.error || t("error", "Could not create the image"));
      }
      showResult(json.image);
    } catch (err) {
      content('<p class="wus-tryon-err">' + escapeHtml(err.message || t("error", "Could not create the image")) + "</p>");
      footer(
        '<button type="button" class="wus-tryon-cta" data-act="retry">' +
          escapeHtml(t("generate", "Generate")) +
          "</button>"
      );
      root.querySelector("[data-act='retry']")?.addEventListener("click", generate);
    }
  }

  function showResult(image) {
    content('<img class="wus-tryon-result" alt="" src="' + image + '">');
    footer(
      '<button type="button" class="wus-tryon-cta secondary" data-act="zoom">' +
        escapeHtml(t("zoom", "Full screen")) +
        "</button>" +
        '<button type="button" class="wus-tryon-cta" data-act="share">' +
        escapeHtml(t("share", "Share")) +
        "</button>"
    );
    root.querySelector("[data-act='zoom']")?.addEventListener("click", function () {
      openFullscreen(image);
    });
    root.querySelector("[data-act='share']")?.addEventListener("click", function () {
      shareImage(image);
    });
  }

  function openFullscreen(image) {
    document.getElementById("wus-tryon-fs")?.remove();
    var wrap = document.createElement("div");
    wrap.id = "wus-tryon-fs";
    wrap.className = "wus-tryon-fs";
    wrap.innerHTML =
      '<button type="button" class="wus-tryon-fs-close" aria-label="Close">×</button><img alt="" src="' +
      image +
      '">';
    document.body.appendChild(wrap);
    var img = wrap.querySelector("img");
    zoomScale = 1;
    wrap.querySelector(".wus-tryon-fs-close").addEventListener("click", function () {
      wrap.remove();
    });
    wrap.addEventListener("click", function (e) {
      if (e.target === wrap) wrap.remove();
    });
    img.addEventListener("click", function (e) {
      e.stopPropagation();
      zoomScale = zoomScale === 1 ? 2 : 1;
      img.style.transform = "scale(" + zoomScale + ")";
    });
    var pinch = 0;
    wrap.addEventListener(
      "touchstart",
      function (e) {
        if (e.touches.length === 2) {
          var dx = e.touches[0].clientX - e.touches[1].clientX;
          var dy = e.touches[0].clientY - e.touches[1].clientY;
          pinch = Math.hypot(dx, dy);
        }
      },
      { passive: true }
    );
    wrap.addEventListener(
      "touchmove",
      function (e) {
        if (e.touches.length !== 2 || !pinch) return;
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        var next = Math.hypot(dx, dy) / pinch;
        zoomScale = Math.min(4, Math.max(1, next));
        img.style.transform = "scale(" + zoomScale + ")";
      },
      { passive: true }
    );
  }

  async function shareImage(dataUrl) {
    try {
      var blob = await (await fetch(dataUrl)).blob();
      var file = new File([blob], "try-on.jpg", { type: blob.type || "image/jpeg" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: t("title", "Try it on") });
        return;
      }
    } catch (_e) {}
    var a = document.createElement("a");
    a.href = dataUrl;
    a.download = "try-on.jpg";
    a.click();
  }

  function iconFlip() {
    return (
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M4 8.5A7 7 0 0 1 16.5 5.2"/><path d="m15 3.2 1.6 2.2-2.5.6"/>' +
      '<path d="M20 15.5A7 7 0 0 1 7.5 18.8"/><path d="m9 20.8-1.6-2.2 2.5-.6"/>' +
      '<rect x="7.2" y="8.2" width="9.6" height="7.2" rx="1.6"/>' +
      '<circle cx="12" cy="11.8" r="1.8"/>' +
      '<path d="M9.2 8.2 10.1 6.8h3.8l.9 1.4"/>' +
      "</svg>"
    );
  }

  function iconTripod() {
    return (
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="8" y="2.5" width="8" height="6" rx="1.4"/>' +
      '<circle cx="12" cy="5.5" r="1.5"/>' +
      '<path d="M9.2 2.5 10 1.4h4l.8 1.1"/>' +
      '<path d="M12 8.5v3"/>' +
      '<path d="M12 11.5 6.2 21"/>' +
      '<path d="M12 11.5 17.8 21"/>' +
      '<path d="M12 11.5V21"/>' +
      "</svg>"
    );
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  function open(opts) {
    root = document.getElementById("wus-tryon-root");
    if (!root) return;
    if (root.parentElement !== document.body) document.body.appendChild(root);
    products = (opts && opts.products) || [];
    pickMode = !!(opts && opts.pick);
    selectedIds = {};
    if (!pickMode && products[0]) selectedIds[String(products[0].id)] = true;
    personBlob = null;
    modelGender = null;
    tripod = false;
    facing = "user";
    root.hidden = false;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    showSource();
  }

  function bind() {
    document.addEventListener("click", function (e) {
      var pdp = e.target.closest("[data-wus-tryon-open]");
      if (pdp) {
        open({
          pick: false,
          products: [
            {
              id: Number(pdp.getAttribute("data-wus-tryon-product")),
              title: pdp.getAttribute("data-wus-tryon-title"),
              imageUrl: pdp.getAttribute("data-wus-tryon-image"),
              ageGroup: pdp.getAttribute("data-wus-tryon-age"),
              gender: pdp.getAttribute("data-wus-tryon-gender"),
              productType: pdp.getAttribute("data-wus-tryon-type"),
              division: pdp.getAttribute("data-wus-tryon-division"),
              sku: pdp.getAttribute("data-wus-tryon-sku"),
            },
          ],
        });
        return;
      }
      var cart = e.target.closest("[data-wus-tryon-cart]");
      if (cart) {
        var node =
          cart.closest(".wus-tryon-cart")?.querySelector("[data-wus-tryon-cart-json]") ||
          document.querySelector("[data-wus-tryon-cart-json]");
        var list = [];
        try {
          list = JSON.parse(node ? node.textContent : "[]");
        } catch (_e) {
          list = [];
        }
        open({ pick: true, products: list });
      }
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-tryon-close]")) close();
      if (e.target.matches("[data-tryon-overlay]")) close();
    });
  }

  window.WusTryon = { open: open, close: close };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind);
  else bind();
})();
